export default __webpack_public_path__ + "static/media/booking.ab1f354a.svg";